import namespace from '../../smartpak/smartpak';
import swapNavTab from "./swapnavtab";

namespace('kentico')._swapNavTab = swapNavTab;

swapNavTab();
